export const SET_USER_TOKEN = "SET_USER_TOKEN";
export const REQUEST_VERIFY_TOKEN = "REQUEST_VERIFY_TOKEN";
export const REQUEST_VERIFY_TOKEN_SUCCESS = "REQUEST_VERIFY_TOKEN_SUCCESS";
export const REQUEST_VERIFY_TOKEN_FAILED = "REQUEST_VERIFY_TOKEN_FAILED";
export const VERIFY_USER = "VERIFY_USER";
export const VERIFY_USER_SUCCESS = "VERIFY_USER_SUCCESS";
export const VERIFY_USER_FAILED = "VERIFY_USER_FAILED";
